import { Component, ElementRef, HostBinding, OnDestroy, OnInit, Renderer2, ViewEncapsulation, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { EguardConfigService } from '../core/services/config.service';
import { EguardNavbarVerticalComponent } from './shared/components/navbar/vertical/navbar-vertical.component';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationStart, NavigationEnd, Router } from '@angular/router';
import { LocalUserService } from './shared/services/localUser';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { DataShareService } from './shared/services/data-share.service';
import { CognitoUtil } from './shared/services/cognito.service';
import { TimeOutDialogComponent } from './shared/dialog/time-out-dialog/time-out-dialog.component';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'eguard-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [LocalUserService]
})
export class EguardMainComponent implements OnInit, OnDestroy {
  onSettingsChanged: Subscription;
  eguardSettings: any;
  currentRoute: string;
  @HostBinding('class.disable-perfect-scrollbar') disableCustomScrollbars;
  @HostBinding('class.boxed') boxed;

  path = '/dashboard';
  @ViewChild('sidebar') navbar;

  showMenuButton = true;

  showNav = false;
  isNavStart = null;
  firstTime: boolean = true;
  lastLoginTime: string;
  currentTime = new Date()
  lastTime: Number;

  sampleInterval;
  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    private location: Location,
    private eguardConfig: EguardConfigService,
    private router: Router,
    private cognito: CognitoUtil,
    private localUser: LocalUserService
  ) {



    this.onSettingsChanged =
      this.eguardConfig.onSettingsChanged
        .subscribe(
          (newSettings) => {
            this.eguardSettings = newSettings;
            this.disableCustomScrollbars = !this.eguardSettings.customScrollbars;
            this.boxed = this.eguardSettings.layout.mode === 'boxed';
          });

    this.lastLoginTime = localStorage.getItem('lastLoginTime');

  }

  ngOnInit() {
    this.path = window.location.pathname;

    this.router.events.subscribe(event => {
      this.isNavStart = false;
      if (event instanceof NavigationStart) {
        this.isNavStart = true;
      }
      if (event instanceof NavigationEnd) {
        switch (event.url) {
          case '':
          case '/':
          case '/login':
            this.showNav = false;
            break;
          default:
            if (this.localUser.getUser() === null) {
              this.router.navigate(['login']);
            }
            this.showNav = true;
            break;
        }
      }
    });

    // if (this.lastLoginTime) {
    //   if (moment().valueOf() < moment(this.lastLoginTime).add(30, 'm').valueOf()) {
    //     if (this.lastLoginTime) {
    //       localStorage.removeItem('lastLoginTime');
    //     }
    //     localStorage.setItem('lastLoginTime', this.currentTime.toISOString());
    //   } else {
    //     this.sampleInterval = setInterval(() => {
    //       if (this.isNavStart && this.isNavStart !== null && this.isNavStart === false) {
    //         clearInterval(this.sampleInterval);
    //         localStorage.removeItem('userDetails');
    //         this.cognito.logout();
    //         this.router.navigate(['login']);
    //       }
    //     }, 1000);
    //   }
    // } else {
    //   localStorage.setItem('lastLoginTime', this.currentTime.toISOString());
    // }
  }

  ngOnDestroy() {
    this.onSettingsChanged.unsubscribe();
  }

  addClass(className: string) {
    this._renderer.addClass(this._elementRef.nativeElement, className);
  }

  removeClass(className: string) {
    this._renderer.removeClass(this._elementRef.nativeElement, className);
  }

  openMenu() {
    this.navbar.toggleBar();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts